import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

type ModalPanelProps = {
    children: React.ReactNode;
    footer: React.ReactNode;
    // goes up each time a tab is clicked, the one that is showing included: that's when to focus the text box
    focusRequest?: number;
};

// What a tab of the site select modal shows: its content, which scrolls, over the button that goes on.
const ModalPanel = ({ children, footer, focusRequest = 0 }: ModalPanelProps) => {
    const bodyRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (focusRequest > 0) {
            // the search, the postcode or the table number: whichever text box there is
            bodyRef.current?.querySelector<HTMLInputElement>('input:not([type=radio]):not([type=checkbox]):not(:disabled)')?.focus();
        }
    }, [focusRequest]);

    return (
        <>
            <Body ref={bodyRef}>{children}</Body>
            <Footer className="site-select-footer">{footer}</Footer>
        </>
    );
};

const Body = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 20px 24px;

    @media screen and (max-width: 767px) {
        padding: 20px 16px;
    }
`;

// Drawn as the menu page's footer is, with its button the width of it
const Footer = styled.div`
    flex: none;
    display: flex;
    justify-content: center;
    padding: 16px;
    background: var(--layouts_footer_bg);
    border-top: var(--layouts_footer_border);
    box-shadow: 0 -1px 4px rgb(0 0 0 / 8%);

    button {
        width: 100%;
        height: 48px;
        padding: 0 16px;
    }

    @media screen and (max-width: 767px) {
        padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
    }
`;

export default ModalPanel;
